import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

const STATUS_LABELS = {
    pending: { label:'รอดำเนินการ', color:'#ffc107', icon:'fas fa-clock' },
    contacted: { label:'ติดต่อแล้ว', color:'#17a2b8', icon:'fas fa-phone' },
    quoted: { label:'เสนอราคาแล้ว', color:'#6610f2', icon:'fas fa-file-invoice-dollar' },
    confirmed: { label:'ยืนยันเดินทาง', color:'#28a745', icon:'fas fa-check-circle' },
    closed: { label:'ปิดเคส', color:'#6c757d', icon:'fas fa-times-circle' }
};

export class ConsoleHome extends Component {
    constructor(props) {
        super(props);
        this.state = { programs: [], requests: [], loading: true };
    }

    componentDidMount() {
        Promise.all([
            fetch('api/programplus?includeInactive=1').then(r => r.ok ? r.json() : []),
            fetch('api/grouprequest').then(r => r.ok ? r.json() : [])
        ]).then(([programs, requests]) => this.setState({ programs, requests, loading: false }))
          .catch(() => this.setState({ loading: false }));
    }

    getTopViewed() {
        return [...this.state.programs]
            .filter(p => p.isActive !== 0)
            .sort((a, b) => (b.viewCount || 0) - (a.viewCount || 0))
            .slice(0, 10);
    }

    getNoSchedule() {
        var today = dayjs().format('YYYY-MM-DD');
        return this.state.programs.filter(p => {
            if (p.isActive === 0) return false;
            var periods = p.periods || [];
            // no periods at all → active without schedule
            if (periods.length === 0) return true;
            // all periods are in the past → expired, don't show
            var future = periods.some(pd => pd.endDate && pd.endDate >= today);
            return !future;
        });
    }

    getStatusCounts() {
        var counts = { pending:0, contacted:0, quoted:0, confirmed:0, closed:0 };
        this.state.requests.forEach(r => { if (counts[r.status] !== undefined) counts[r.status]++; });
        return counts;
    }

    render() {
        var { programs, requests, loading } = this.state;
        var topViewed = this.getTopViewed();
        var noSchedule = this.getNoSchedule();
        var statusCounts = this.getStatusCounts();
        var totalViews = programs.reduce((s, p) => s + (p.viewCount || 0), 0);

        return (
            <div style={{ padding: 20 }}>
                <div className="mb-4">
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>ภาพรวมระบบจัดการโปรแกรมทัวร์</p>
                </div>

                {/* Summary cards */}
                <div className="row mb-4">
                    <div className="col-md-3 col-sm-6 mb-3">
                        <div style={{ background:'linear-gradient(135deg,#dc3545,#c02911)', color:'#fff', borderRadius:12, padding:20, boxShadow:'0 4px 20px rgba(220,53,69,0.2)' }}>
                            <div style={{ fontSize:12, opacity:0.85 }}>โปรแกรมทั้งหมด</div>
                            <div style={{ fontSize:32, fontWeight:800, lineHeight:1.2 }}>{programs.length}</div>
                            <div style={{ fontSize:11, opacity:0.85 }}>Active: {programs.filter(p => p.isActive !== 0).length}</div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 mb-3">
                        <div style={{ background:'linear-gradient(135deg,#17a2b8,#117a8b)', color:'#fff', borderRadius:12, padding:20, boxShadow:'0 4px 20px rgba(23,162,184,0.2)' }}>
                            <div style={{ fontSize:12, opacity:0.85 }}>ยอด View รวม</div>
                            <div style={{ fontSize:32, fontWeight:800, lineHeight:1.2 }}>{totalViews.toLocaleString()}</div>
                            <div style={{ fontSize:11, opacity:0.85 }}><i className="fas fa-eye"></i> ทุกโปรแกรม</div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 mb-3">
                        <div style={{ background:'linear-gradient(135deg,#ffc107,#e0a800)', color:'#fff', borderRadius:12, padding:20, boxShadow:'0 4px 20px rgba(255,193,7,0.2)' }}>
                            <div style={{ fontSize:12, opacity:0.9 }}>คำขอรอดำเนินการ</div>
                            <div style={{ fontSize:32, fontWeight:800, lineHeight:1.2 }}>{statusCounts.pending}</div>
                            <div style={{ fontSize:11, opacity:0.9 }}><i className="fas fa-clock"></i> ต้องติดต่อกลับ</div>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 mb-3">
                        <div style={{ background:'linear-gradient(135deg,#28a745,#1e7e34)', color:'#fff', borderRadius:12, padding:20, boxShadow:'0 4px 20px rgba(40,167,69,0.2)' }}>
                            <div style={{ fontSize:12, opacity:0.9 }}>ยืนยันเดินทาง</div>
                            <div style={{ fontSize:32, fontWeight:800, lineHeight:1.2 }}>{statusCounts.confirmed}</div>
                            <div style={{ fontSize:11, opacity:0.9 }}><i className="fas fa-check-circle"></i> ลูกค้ายืนยันแล้ว</div>
                        </div>
                    </div>
                </div>

                {/* Quick actions */}
                <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', marginBottom:20 }}>
                    <h6 style={{ fontWeight:700, marginBottom:14 }}><i className="fas fa-bolt"></i> ทางลัด</h6>
                    <div className="row g-3">
                        <div className="col-md-3 col-sm-6">
                            <Link to="/console/programplus" className="btn btn-outline-danger w-100 d-flex flex-column align-items-center" style={{ padding:20, borderRadius:10 }}>
                                <i className="fas fa-globe-asia fa-2x mb-2"></i>
                                <span style={{ fontWeight:700 }}>โปรแกรมทัวร์</span>
                                <small style={{ fontSize:11, color:'#888' }}>{programs.length} รายการ</small>
                            </Link>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <Link to="/console/programplus/create" className="btn btn-outline-danger w-100 d-flex flex-column align-items-center" style={{ padding:20, borderRadius:10 }}>
                                <i className="fas fa-plus-circle fa-2x mb-2"></i>
                                <span style={{ fontWeight:700 }}>สร้างโปรแกรม</span>
                                <small style={{ fontSize:11, color:'#888' }}>เพิ่มโปรแกรมใหม่</small>
                            </Link>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <Link to="/console/tools/homeslide" className="btn btn-outline-danger w-100 d-flex flex-column align-items-center" style={{ padding:20, borderRadius:10 }}>
                                <i className="fas fa-images fa-2x mb-2"></i>
                                <span style={{ fontWeight:700 }}>จัดการสไลด์</span>
                                <small style={{ fontSize:11, color:'#888' }}>Home slideshow</small>
                            </Link>
                        </div>
                        <div className="col-md-3 col-sm-6">
                            <Link to="/console/grouprequest" className="btn btn-outline-danger w-100 d-flex flex-column align-items-center" style={{ padding:20, borderRadius:10, position:'relative' }}>
                                <i className="fas fa-users fa-2x mb-2"></i>
                                <span style={{ fontWeight:700 }}>คำขอจัดกรุ๊ป</span>
                                <small style={{ fontSize:11, color:'#888' }}>{requests.length} รายการ</small>
                                {statusCounts.pending > 0 && <span style={{ position:'absolute', top:10, right:10, background:'#dc3545', color:'#fff', padding:'2px 10px', borderRadius:12, fontSize:11, fontWeight:700 }}>{statusCounts.pending} ใหม่</span>}
                            </Link>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : (
                    <div className="row">
                        {/* Top view */}
                        <div className="col-md-6 mb-4">
                            <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', height:'100%' }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 style={{ fontWeight:700, margin:0 }}><i className="fas fa-fire" style={{ color:'#dc3545' }}></i> Top View โปรแกรม</h6>
                                    <small style={{ color:'#888' }}>10 อันดับแรก</small>
                                </div>
                                {topViewed.length === 0 ? (
                                    <div className="text-center py-4" style={{ color:'#bbb' }}>ยังไม่มีโปรแกรม</div>
                                ) : topViewed.map((p, i) => (
                                    <Link key={p.id} to={'/console/programplus/view/' + p.id} style={{ textDecoration:'none', color:'inherit' }}>
                                        <div style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 0', borderBottom:'1px solid #f0f0f0' }}>
                                            <div style={{ width:28, height:28, borderRadius:'50%', background: i < 3 ? '#dc3545' : '#adb5bd', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:13, flexShrink:0 }}>{i+1}</div>
                                            <div style={{ flex:1, minWidth:0 }}>
                                                <div style={{ fontSize:13, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{p.code} {p.name}</div>
                                                {p.destinations && <div style={{ fontSize:11, color:'#888', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{p.destinations}</div>}
                                            </div>
                                            <div style={{ fontSize:13, fontWeight:700, color:'#dc3545', whiteSpace:'nowrap' }}>
                                                <i className="fas fa-eye"></i> {(p.viewCount || 0).toLocaleString()}
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* No schedule */}
                        <div className="col-md-6 mb-4">
                            <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)', height:'100%' }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 style={{ fontWeight:700, margin:0 }}><i className="fas fa-calendar-times" style={{ color:'#ffc107' }}></i> รอเพิ่มกำหนดการ</h6>
                                    <small style={{ color:'#888' }}>{noSchedule.length} รายการ</small>
                                </div>
                                {noSchedule.length === 0 ? (
                                    <div className="text-center py-4" style={{ color:'#bbb' }}>ทุกโปรแกรมมีกำหนดการเดินทาง</div>
                                ) : noSchedule.slice(0,10).map(p => (
                                    <Link key={p.id} to={'/console/programplus/edit/' + p.id} style={{ textDecoration:'none', color:'inherit' }}>
                                        <div style={{ display:'flex', alignItems:'center', gap:12, padding:'10px 0', borderBottom:'1px solid #f0f0f0' }}>
                                            <i className="fas fa-exclamation-circle" style={{ color:'#ffc107', fontSize:18 }}></i>
                                            <div style={{ flex:1, minWidth:0 }}>
                                                <div style={{ fontSize:13, fontWeight:600, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{p.code} {p.name}</div>
                                                {p.destinations && <div style={{ fontSize:11, color:'#888', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>{p.destinations}</div>}
                                            </div>
                                            <i className="fas fa-edit" style={{ color:'#888' }}></i>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </div>

                        {/* Request status breakdown */}
                        <div className="col-12 mb-4">
                            <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 2px 12px rgba(0,0,0,0.06)' }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 style={{ fontWeight:700, margin:0 }}><i className="fas fa-chart-pie" style={{ color:'#17a2b8' }}></i> สรุปสถานะคำขอจัดกรุ๊ป</h6>
                                    <small style={{ color:'#888' }}>ทั้งหมด {requests.length} รายการ</small>
                                </div>
                                <div className="row g-3">
                                    {Object.keys(STATUS_LABELS).map(k => {
                                        var s = STATUS_LABELS[k];
                                        var n = statusCounts[k] || 0;
                                        return (
                                            <div key={k} className="col-md col-sm-6">
                                                <Link to={'/console/grouprequest'} style={{ textDecoration:'none' }}>
                                                    <div style={{ borderLeft:'4px solid '+s.color, padding:'10px 14px', background:'#fafbfc', borderRadius:6 }}>
                                                        <div style={{ fontSize:12, color:'#666' }}><i className={s.icon} style={{ color:s.color }}></i> {s.label}</div>
                                                        <div style={{ fontSize:24, fontWeight:800, color:'#333' }}>{n}</div>
                                                    </div>
                                                </Link>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
